var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_9_1",
    "data-name": "Component 9 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13.091,
    viewBox: "0 0 18 13.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M10,4c4.97,0,9,2.2,9,4.909v3.273c0,2.711-4.03,4.909-9,4.909-4.882,0-8.856-2.12-9-4.764l0-.145V8.909C1,6.2,5.03,4,10,4Zm0,9.818a12.384,12.384,0,0,1-7.364-2.086v.45c0,1.54,3.177,3.273,7.364,3.273,4.1,0,7.231-1.661,7.36-3.176l0-.1v-.45A12.391,12.391,0,0,1,10,13.818Zm0-8.182c-4.187,0-7.364,1.733-7.364,3.273S5.813,12.182,10,12.182s7.364-1.733,7.364-3.273S14.187,5.636,10,5.636Z",
    transform: "translate(-1 -4)",
    fill: "#002d44",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.d1bbe513016658fcb361b8a537bb54d5.svg";
export { ForwardRef as ReactComponent };